import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import style from './styles.scss';

const Checkbox = ({
  onChange = () => {},
  isChecked = false,
  className = '',
  errorMessage = '',
  isDisabled = false,
  type = 'checkbox',
  label = [],
  name = '',
  id,
  value = 'on',
  ...rest
}) => {
  const handleOnChange = () => {
    if (isDisabled) return false;
    onChange(type === 'checkbox' ? !isChecked : value);
  };

  return (
    <div className={style.container}>
      <div className={style.checkbox}>
        <label className={cn(className, style.label)} htmlFor={id}>
          <input
            {...rest}
            className={style.input}
            type={type}
            name={name}
            onChange={handleOnChange}
            disabled={isDisabled}
            value={value}
            checked={isChecked}
            id={id}
          />
          {label.map((item, index) => <Fragment key={index}>{item}</Fragment>)}
        </label>
      </div>
      {!!errorMessage && <div className={style.error}>{errorMessage}</div> }
    </div>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.array,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
};

export default Checkbox;
